var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { width: "100% !important" }
          },
          [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(_vm._s(_vm.pageTitle))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack()
                  }
                }
              },
              [_vm._v("Back")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { class: _vm.alertClass, attrs: { id: "success-alert" } }, [
            _c("strong", [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "name", placeholder: "Enter Name" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.nameError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "email", placeholder: "Enter Email" },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.emailError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "toggle-password",
                          type: "password",
                          placeholder: "Enter Password",
                          name: "password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstarPassword" }, [
                        _vm._v("*")
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "fa fa-lg fa-eye field-icon toggle-password",
                        attrs: { toggle: "#toggle-password" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.passwordError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmPassword,
                            expression: "confirmPassword"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "toggle-password-confirm",
                          type: "password",
                          name: "confirmPassword",
                          placeholder: "Confirm Password"
                        },
                        domProps: { value: _vm.confirmPassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.confirmPassword = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "requiredstarConfirmPassword" },
                        [_vm._v("*")]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "fa fa-lg fa-eye field-icon toggle-password-confirm",
                        attrs: { toggle: "#toggle-password-confirm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.confirmPasswordError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isNonVVGDealer == "NO"
                    ? [
                        _c("div", { staticClass: "col-6 forms-block" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 paddingleft0" },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-checkbox-group", {
                                    attrs: {
                                      id: "permission",
                                      options: _vm.permissionArr,
                                      name: "permission"
                                    },
                                    model: {
                                      value: _vm.permission,
                                      callback: function($$v) {
                                        _vm.permission = $$v
                                      },
                                      expression: "permission"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _c("div", { staticClass: "paddingleft" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v(
                          "Master Customer Access : \n                                "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isMasterCustomer,
                              expression: "isMasterCustomer"
                            }
                          ],
                          staticClass: "ml-2",
                          attrs: {
                            type: "checkbox",
                            name: "isMasterCustomer",
                            id: "isMasterCustomer"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.isMasterCustomer)
                              ? _vm._i(_vm.isMasterCustomer, null) > -1
                              : _vm.isMasterCustomer
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isMasterCustomer,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isMasterCustomer = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isMasterCustomer = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isMasterCustomer = $$c
                              }
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isNonVVGDealer == "NO"
                    ? [
                        _c("div", { staticClass: "col-12 forms-block" }, [
                          _c("div", { staticClass: "paddingleft0" }, [
                            _c("div", { staticClass: "form-label" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "container",
                                  staticStyle: { padding: "0px !important" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isAllowEnterPO,
                                        expression: "isAllowEnterPO"
                                      }
                                    ],
                                    staticClass: "mr-2",
                                    attrs: {
                                      type: "checkbox",
                                      id: "1",
                                      value: "1"
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.isAllowEnterPO)
                                        ? _vm._i(_vm.isAllowEnterPO, "1") > -1
                                        : _vm.isAllowEnterPO
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.isAllowEnterPO,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "1",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.isAllowEnterPO = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.isAllowEnterPO = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.isAllowEnterPO = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                                        Allow to enter PO# number in Mobile Application\n                                    "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addUpdateCustomer()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addAndContinueBenifitBtn",
                    disabled: _vm.disableButtons.saveAndContinue,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.saveAndContinue },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addUpdateCustomer(
                        (_vm.flag = "Save and Continue")
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "CancelBenifit",
                    disabled: _vm.disableButtons.cancel,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.cancel },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Email : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Password : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Confirm Password : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Permission : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51e36e63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e36e63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/AddUpdateMember.vue
// module id = null
// module chunks = 